<template>
  <a-modal
    :title="modalTitle"
    :visible="visible"
    :mask-closable="false"
    :width="900"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button @click="handleCancel">
        关闭
      </a-button>
    </template>

    <TableActions
      :actions="headerActions"
      @exportResource="exportReleaseRecord"
    />

    <a-table
      :columns="columns"
      :data-source="dataSource"
      :loading="loading"
      :pagination="false"
      style="padding: 16px 0; background-color: #fff;"
      :row-key="(item, index) => index"
    >
      <template
        slot="startDate"
        slot-scope="startDate"
      >
        {{ moment(startDate).format('YYYY-MM-DD') }}
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { queryReleaseRecordCheck, exportReleaseRecord } from '@/api/baseDetail.js'
import moment from 'moment'
import { excelDown } from '@/utils/utils.js'

const headerActions = [
  {
    title: '导出',
    type: 'primary',
    action: 'exportResource',
    apis: ['@baseInfo/Export_Bases']

  }
]

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    initData: {
      type: Object,
      default: null
    },
    resourceId: {
      type: String,
      default: null
    },
    modalTitle: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      headerActions,
      form: {
        baseId: '',
        collectionAmount: '',
        collectionDate: '',
        operateYear: ''
      },
      loading: false,
      columns: [
        {
          title: '产品类型',
          dataIndex: 'productTypeName',
          key: 'productTypeName',
          width: '130px',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          key: 'enterpriseName',
          align: 'center'
        },
        {
          title: '代金券编码',
          dataIndex: 'voucherCode',
          key: 'voucherCode',
          align: 'center'
        },
        {
          title: '补贴金额',
          dataIndex: 'subsidyAmount',
          key: 'subsidyAmount',
          align: 'center'
        },
        {
          title: '开通时间',
          dataIndex: 'startDate',
          key: 'startDate',
          scopedSlots: { customRender: 'startDate' },
          align: 'center'
        },
        {
          title: '运营年度',
          dataIndex: 'operatorYear',
          key: 'operatorYear',
          align: 'center'
        }
      ],
      dataSource: []
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        if (data) {
          this.fetchData()
        }
      }
    }
  },
  methods: {
    moment,
    excelDown,
    async fetchData () {
      this.loading = true
      await queryReleaseRecordCheck({
        resourceId: this.resourceId
      }).then((data) => {
        this.dataSource = data
      })
      this.loading = false
    },
    handleCancel () {
      this.$emit('cancel')
    },
    async exportReleaseRecord () {
      await exportReleaseRecord({
        resourceId: this.resourceId
      }).then((data) => {
        this.excelDown(data)
      })
    }
  }
}
</script>
